import { render } from "./ShowProductAdditionalInfo.vue?vue&type=template&id=752e3f52"
import script from "./ShowProductAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ShowProductAdditionalInfo.vue?vue&type=script&lang=js"

import "./ShowProductAdditionalInfo.vue?vue&type=style&index=0&id=752e3f52&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__